/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_State_ButtonInputs */



/**
* | output |
* | --- |
* | "State" |
*
* @param {Explorer_Info_State_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_state_button = /** @type {((inputs?: Explorer_Info_State_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_State_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Etat")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zustand")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Состояние")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("状态")
	if (locale === "ja") return /** @type {LocalizedString} */ ("州")
	if (locale === "hi") return /** @type {LocalizedString} */ ("राज्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Estado")
	return /** @type {LocalizedString} */ ("State")
});